"use client";

import { useRouter } from "next/navigation";
import { Icon } from "@/components/ui/icon";

interface InviteErrorProps {
  message: string;
}

export function InviteError({ message }: InviteErrorProps) {
  const router = useRouter();
  return (
    <div className="flex flex-col items-center gap-4 py-8">
      <Icon name="IconExclamationCircle" size={32} className="text-red-400" />
      <p className="text-contrast/70 text-sm text-center">{message}</p>
      <button
        onClick={() => router.push("/login")}
        className="text-sm text-primary hover:underline cursor-pointer"
      >
        Go to Login
      </button>
    </div>
  );
}
